import {Component, Input, OnInit} from '@angular/core';
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";


@Component({
    selector: 'im-import-record',
    templateUrl: './im-import-record.component.html',
    standalone: false
})
export class ImImportRecordComponent implements OnInit {

    initialized: boolean = false;
    importRecordData: WidgetData;
    @Input() importId: number;

    ngOnInit() {
        this.refresh();
    }

    refresh() {
        this.initialized = true;
        this.refreshImportRecordData();
    }

    refreshImportRecordData() {

        this.importRecordData = WidgetFactory.createWidgetTableEntityBasicQl('im.object.component.import-record-data.component', 'Import Records', 'im.ImImportRecord');
    }
}
